
const libPictView = require('pict-view');
const libOperationalExplorerConfig = require('../data-explorer/Operational-Explorer-Config.js');

const html = String.raw;

// The explorer view's identity + the mount point this page's template provides for it.
const EXPLORER_HASH = 'PlatformDataExplorer';
const MOUNT_SELECTOR = '#PlatformDataExplorer-Mount';

/**
 * Host page for the operational-database explorer (pict-dataexplorer).
 *
 * Mirrors the TopicPage shape (AutoRender false; renders its chrome into the shared application container).
 * The explorer itself is created + rendered in onAfterRender — not at app init — for two reasons: (1) the
 * destination mount div only exists once this page's template is in the DOM, and (2) the soft preview-card
 * dependency (RecordSetCardManager + the Platform-RecordCards) is registered post-login, so deferring the
 * first render until the user navigates here guarantees the cards are present. createExplorer is idempotent
 * (it reuses the existing explorer view), so re-visiting the page just rebuilds the tree from its roots.
 */
class DataExplorer extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	onAfterRender(pRenderable)
	{
		const tmpProvider = this.pict.providers['Pict-DataExplorer'];
		if (tmpProvider)
		{
			const tmpExplorer = tmpProvider.createExplorer(EXPLORER_HASH,
				Object.assign({ DestinationAddress: MOUNT_SELECTOR }, libOperationalExplorerConfig));
			tmpExplorer.renderExplorer();
		}
		else
		{
			this.pict.log.warn('DataExplorer: the Pict-DataExplorer provider is not registered — cannot render the explorer.');
		}

		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable);
	}
}

module.exports = DataExplorer;

module.exports.default_configuration =
{
	ViewIdentifier: 'DataExplorer',
	DefaultRenderable: 'DataExplorerWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
.dataexplorer-head { display: flex; align-items: center; gap: 0.9rem; max-width: 980px; margin: 0 auto 1.1rem; }
.dataexplorer-ic { display: inline-flex; align-items: center; justify-content: center; width: 2.6rem; height: 2.6rem; border-radius: 12px;
	background: var(--theme-color-background-tertiary, #eef1f5); color: var(--theme-color-brand-primary, #156dd1); font-size: 1.2rem; flex: 0 0 auto; }
.dataexplorer-title { font-size: 1.5rem; font-weight: 700; line-height: 1.1; color: var(--theme-color-text-primary, #1f2733); margin: 0; }
.dataexplorer-sub { font-size: 0.92rem; color: var(--theme-color-text-muted, #6b7686); margin: 0.15rem 0 0; }
.dataexplorer-panel { max-width: 980px; margin: 0 auto; background: var(--theme-color-background-primary, #fff);
	border: 1px solid var(--theme-color-border-light, #eef1f5); border-radius: 12px; padding: 0.9rem 1rem; min-height: 60vh; }
`,

	Templates:
	[
		{
			Hash: 'DataExplorer-Template',
			Template: html`
				<section class="section">
					<div class="container">
						<div class="dataexplorer-head">
							<span class="dataexplorer-ic"><i class="fas fa-sitemap"></i></span>
							<div>
								<h1 class="dataexplorer-title">Data Explorer</h1>
								<p class="dataexplorer-sub">Browse the operational database as an expandable graph — open a record to drill into its related collections.</p>
							</div>
						</div>
						<div class="dataexplorer-panel">
							<div id="PlatformDataExplorer-Mount"></div>
						</div>
					</div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'DataExplorerWrap',
			TemplateHash: 'DataExplorer-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};
